<div class="filter-list-item-container">
  <div class="content">
    <div class="filter-item">
      <div class="header">
        <div class="name">
          {{ item.name }}
        </div>
        <div class="icon" (click)="toggleValues()">
          <img *ngIf="showValues" src="./assets/ui/shared/icons/drop_down_arrow_up_icon.svg" alt="drop_down_up_icon" title="drop_down_up_icon" />
          <img *ngIf="!showValues" src="./assets/ui/shared/icons/drop_down_arrow_down_icon.svg" alt="drop_down_down_icon" title="drop_down_down_icon" />
        </div>
      </div>
      <div class="values" *ngIf="showValues">
        <kion-checkbox [boxes]="boxes" (boxToggled)="boxToggled($event)"></kion-checkbox>
      </div>
    </div>
  </div>
</div>
